import { isPresent } from "neetocist";
import { Avatar, Typography } from "neetoui";

import DateFormat from "components/DateFormat";
import MoreDropdown from "components/MoreDropdown";

const CommentHeader = ({ user, comment, info, actions }) => {
  const avatar = { name: user.name, imageUrl: user.profileImageUrl };

  return (
    <div className="neeto-ui-bg-gray-100 neeto-ui-border-gray-300 flex items-center justify-between rounded-t-md border-b py-1 pe-1 ps-4">
      <div className="flex min-w-0 flex-grow flex-wrap items-center gap-2">
        <Avatar size="medium" user={avatar} />
        <Typography
          className="neeto-ui-text-gray-700"
          style="body2"
          weight="semibold"
        >
          {user.name}
        </Typography>
        <Typography className="neeto-ui-text-gray-700" style="body2">
          •
        </Typography>
        {info && (
          <>
            <Typography
              className="neeto-ui-text-gray-500 lowercase"
              style="body2"
            >
              {info}
            </Typography>
            <Typography className="neeto-ui-text-gray-700" style="body2">
              •
            </Typography>
          </>
        )}
        {comment.createdAt && (
          <DateFormat.FromNow
            date={comment.createdAt}
            typographyProps={{
              style: "body2",
              className: "neeto-ui-text-gray-500",
            }}
          />
        )}
      </div>
      {isPresent(actions) && (
        <MoreDropdown
          dropdownButtonProps={{ className: "self-start fles-shrink-0" }}
          dropdownProps={{ position: "bottom-start" }}
          menuItems={actions}
        />
      )}
    </div>
  );
};

export default CommentHeader;
